import { useContext, useState, useEffect } from 'react';
import { appStore } from 'store/app';

const usePreOrder = () => {
  const [{ customData }] = useContext(appStore);
  const [isPreOrder, setIsPreOrder] = useState(false);
  const [preOrderItems, setPreOrderItems] = useState([]);

  let hasBoots = false;
  if (customData.bootsList) {
    hasBoots = true;
  }
  
  const sizeId = customData.bottle.size;

  useEffect(() => {
    // 発送予定日と在庫数と販売継続フラグから予約販売を判定（ボトル）
    const isPreOrderBottle =
      customData.bottle.inventory_policy === "continue" &&
      Number(customData.bottle.inventory_quantity) <= 0&&
      customData.bottle.next_incoming_date !=='';

    // 発送予定日と在庫数と販売継続フラグから予約販売を判定（パーツ）
    const preOrderParts = customData.partsList.filter(
      (item) => item.next_incoming_date && Number(item.inventory_quantity) <= 0 && item.inventory_policy ==="continue"
    );

    let isPreOrderBoots = false;
    if (hasBoots) {
      const selectedBoot = customData.bootsList[0].variants[sizeId];
      isPreOrderBoots =
        selectedBoot.inventory_policy === "continue" &&
        Number(selectedBoot.inventory_quantity) <= 0 &&
        selectedBoot.next_incoming_date !=='';
    }
    //発送予定日と在庫数と販売継続フラグから予約販売を判定（底ラバー）


    if (isPreOrderBottle || preOrderParts.length || isPreOrderBoots) {
      setIsPreOrder(true);

      const list = [];

      if (isPreOrderBottle) {
        list.push({
          name: customData.bottle.size + " / " + customData.bottle.color,
          text: (customData.bottle.next_incoming_date_label),
        });
      }

      preOrderParts.map((item) => {
        return list.push({
          name: item.name,
          product_name: item.product_name,
          text: (item.next_incoming_date_label),
        });
      });

      if (isPreOrderBoots) {
        const selectedBoot = customData.bootsList[0].variants[sizeId];
        const selectedColor = customData.bootsList[0].name;
        list.push({
          name: selectedBoot.name + "（" + selectedColor + "）",
          text: (selectedBoot.next_incoming_date_label),
        });
      }

      setPreOrderItems(list);
    } else {
      setIsPreOrder(false);
      setPreOrderItems([]);
    }
    // eslint-disable-next-line
  }, [customData]);

  return [isPreOrder, preOrderItems];
};

export default usePreOrder;
